import { render, staticRenderFns } from "./wsDataTable.vue?vue&type=template&id=0cc71721&scoped=true&"
import script from "./wsDataTable.vue?vue&type=script&lang=js&"
export * from "./wsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./wsDataTable.vue?vue&type=style&index=0&id=0cc71721&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc71721",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDataTable,VDivider,VFadeTransition,VHover,VIcon,VSheet})
